export default "__VITE_ASSET__BODEgEMU__"